import { computed, nextTick, ref, toRaw } from 'vue'
import { searchProducts, searchUrl } from '@/apis/search'
import { goodsProductList } from '@/apis/usercenter'

export const formatCommonProduct = (v: any, rate: number) => ({
  ...v,
  id: v.productCode,
  code: v.productCode,
  name: v.productTitle,
  img: v.productMainImg,
  type: 'common',
  price: v.productSellPrice ?? 0,
  PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0
})

const formatCommonProductArr = (data: any, rate: number) => {
  return (data || []).map((t: any) => formatCommonProduct(t, rate))
}

export default (model: any, keyword: any, rate:any, emits: any) => {
  const loading: any = ref(false)
  const list: any = ref([])
  const total = ref()
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })
  const isCollect = computed(() => model.value.channel === '5')
  const useApi: any = () => isCollect.value ? goodsProductList : searchProducts
  const apiParams = () => isCollect.value ? { ...toRaw(pageData.value) } : { ...toRaw(pageData.value), ...productParams.value }
  const productParams = ref()
  const getList = () => {
    if (!isCollect.value) {
      if (!keyword.value) return
      const kw = keyword.value.trim()
      if (kw) {
        model.value.keyword = kw
        productParams.value = { ...model.value }
      }
    }
    list.value = []
    const api = useApi()
    const filter = apiParams()
    loading.value = true
    api(filter).then((res: any) => {
      list.value = formatCommonProductArr(res.data?.records, rate.value)
      total.value = res.data.total
      nextTick(() => {
        emits('update:list', list.value)
      })
    }).finally(() => { loading.value = false })
  }

  return [
    loading,
    pageData,
    list,
    total,
    getList
  ]
}
